<template>
  <modal
    :title="$t(title)"
    :appendToBody="true"
    :top="'12vh'"
    :visible.sync="isShowDialog"
  >
    <div class="configNetPage">
      <!-- 基本信息 -->
      <ul class="base-info">
        <li v-for="item in baseMsg" :key="item.key">
          <span class="label">{{ $t(item.text) }}：</span>
          <span class="value">
            <template
              v-if="item.key === 'config_status' || item.key === 'type'"
            >
              <span>{{ changeTextFn(item.key, cmdObj[item.key]) }}</span>
            </template>
            <template v-else-if="item.key === 'step'">
              <span
                v-show="
                  cmdObj[item.key] && typeof cmdObj[item.key] === 'string'
                "
              >
                <span>{{ stepFn(cmdObj[item.key]) }}</span>
              </span>
            </template>
            <template v-else-if="item.isBool">
              <span v-if="cmdObj['config_status'] !== 2">{{
                objFn1(cmdObj[item.key])
              }}</span>
              <span style="color:red">{{ objFn2(cmdObj[item.key]) }}</span>
            </template>
            <span v-else> {{ cmdObj[item.key] }}</span>
          </span>
        </li>
      </ul>
    </div>
  </modal>
</template>

<script>
import { configStep, gatewayType } from '@/utils/convert'

export default {
  props: {
    title: {},
    isShow: {},
    cmdObj: {},
    sensorWay: {}
  },
  computed: {
    isShowDialog: {
      get: function () {
        return this.isShow
      },
      set: function (val) {
        this.$emit('update:isShow', val) // 可以优化成model  或者minx
      }
    }
  },
  watch: {
    cmdObj (newVal) {
      this.baseMsg = [
        {
          text: 'public.belong',
          key: 'url'
        },
        {
          text: 'device.gateway_name',
          key: 'name'
        },
        {
          text: 'Mac',
          key: 'mac'
        },
        {
          text: 'device.config_status',
          key: 'config_status'
        },
        {
          text: 'public.carrier',
          key: 'carrierName'
        },
        {
          text: 'public.type',
          key: 'type'
        },
        {
          key: 'extPanId',
          text: 'Ext Pan ID',
          isBool: true
        },
        {
          key: 'channelPage',
          text: 'Join Attemp',
          isBool: true
        },
        {
          key: 'channelMask',
          text: 'device.channel_mask',
          isBool: true
        },
        {
          text: 'public.command',
          key: 'cmd'
        },
        {
          text: $t('integration.configuration_steps'),
          key: 'step'
        }
      ]
      if (this.sensorWay === 'unbind') {
        this.baseMsg = this.baseMsg.filter(item => item.key !== 'carrierName')
      }
    }
  },
  data () {
    return {
      baseMsg: []
    }
  },
  methods: {
    changeTextFn (key, value) {
      if (key === 'type') {
        return this.$t(gatewayType[value].title)
      } else {
        return value === 0
          ? $t('device.wait_config')
          : value === 1
            ? $t('device.configured')
            : $t('device.configured')
      }
    },
    objFn1 (obj) {
      return obj ? obj.current + '-->' : ''
    },
    objFn2 (obj) {
      return obj ? obj.modify : ''
    },
    stepFn (value) {
      return configStep[value] && this.$t(configStep[value].title)
    }
  }
}
</script>

<style lang="scss" scoped>
.configNetPage {
  .base-info {
    display: grid;
    grid-template-columns: max-content 1fr;
    column-gap: 10px;
    padding: 10px 20px;
    max-height: 500px;
    overflow: auto;

    li {
      display: contents;
    }

    .label {
      text-align: right;
      line-height: 32px;
      color: #606266;
      font-size: 14px;
    }

    .value {
      line-height: 32px;
      color: #606266;
      font-size: 14px;
      text-align: left;
    }
  }
}
</style>
